import { render } from "./DivLoader.vue?vue&type=template&id=6d0a534a"
import script from "./DivLoader.vue?vue&type=script&lang=js"
export * from "./DivLoader.vue?vue&type=script&lang=js"

import "./DivLoader.vue?vue&type=style&index=0&id=6d0a534a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__